import { CalendarCheckIcon, CalendarClockIcon, CalendarIcon, CalendarX2Icon } from 'lucide-react'

import { Text } from '@/components/ui/text'
import { JobBoardAvailability } from '@/types/application/job-board'
import { getDistanceToNowStrict, getFormattedDate, isAfterToday, isMoreThanOneMonthBeforeToday } from '@/utils/date'

function displayAvailability(availability: JobBoardAvailability | null) {
  if (!availability) {
    return (
      <>
        <CalendarIcon className="text-muted-foreground" size={16} />
        <Text size="xs" truncate>
          -
        </Text>
      </>
    )
  }

  if (isAfterToday(availability.value)) {
    return (
      <>
        <CalendarX2Icon className="shrink-0 text-destructive" size={16} />
        <Text size="xs" truncate>
          {getDistanceToNowStrict(availability.value)}
        </Text>
      </>
    )
  }

  if (isMoreThanOneMonthBeforeToday(availability.value)) {
    return (
      <>
        <CalendarClockIcon className="shrink-0 text-yellow" size={16} />
        <Text size="xs" truncate>
          {getFormattedDate(availability.value)}
        </Text>
      </>
    )
  }

  return (
    <>
      <CalendarCheckIcon className="shrink-0 text-green" size={16} />
      <Text size="xs" truncate>
        Now
      </Text>
    </>
  )
}

export function Availability({ availability }: { availability: JobBoardAvailability | null }) {
  return <div className="flex items-center gap-x-1">{displayAvailability(availability)}</div>
}
